import {api} from '../../system/api';

export default {
    updateBagSize: (id, data) => api.put(`bag-sizes/${id}`, data),
    fetchDetailBagSize: (id) => api.get(`bag-sizes/${id}`),
    fetchBagSizes: (params) => api.get('bag-sizes', {params}),
    fetchSuggestBagSize: (params) => api.get('bag-sizes/suggest', {params})
};
